module.exports = __webpack_public_path__ + "img/smartParking.e13f9c0a.svg";